import React from 'react';
import { Image } from '@src/components/Image';
import { STATIC_MEDIA_DOMAIN } from '@src/constants';
import './styles.scss';

export default function EmptyState() {
  return (
    <div className="notification-center-empty-wrapper">
      <Image
        className="notification-center-empty-wrapper__image"
        src={`${STATIC_MEDIA_DOMAIN}/images/empty-notification-center.png`}
      />

      <div className="notification-center-empty-wrapper__title">No new notifications!</div>

      <div className="notification-center-empty-wrapper__text">
        Notifications about your openings, new candidates and other interesting activity will appear here.
      </div>
    </div>
  );
}
